<template>
  <v-container>
      <v-row justify="center">
          <v-col cols="12" sm="6">
              <h1>{{this.langData.landing.title}}</h1>
              <p v-html="this.langData.landing.body"></p>
              <span class="rays">
                <v-btn secondary light uppercase outlined color="#e93e8f" @click="$router.push('/form')">{{this.langData.landing.cta}}</v-btn>
              </span>
          </v-col>
          <v-col cols="12" sm="6">
              <v-img
                :src="heartsImage.src"
                contain
            ></v-img>
          </v-col>
      </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Landing',
  props:['siteData', 'langData'],
  data: () => ({
    valid: false,
    heartsImage : {src:require('@/assets/HeartsImg.png')},
    newStage: 1
  }),
  methods :{
      loadForm : function() {
          this.$emit('landing-done', this.newStage);
      }
  }
};
</script>

<style scoped>
  h1,p {
    color:#e73f8d;
  }
  p {
    font-size:20px;
    font-weight:600;
  }
  h1 {
    text-transform: uppercase;
    padding-bottom: 16px;
  } 
  .v-btn {
    letter-spacing: 0.0292857143em;
  }
  .v-btn.v-size--default {
    font-size: 0.675rem;
  }
  .v-btn:not(.v-btn--round).v-size--default {
    height: 36px;
    min-width: 64px;
    padding: 0 16px;
  }
</style>